<template>
  <section id="about-gym" class="py-5">
    <div class="container">
      <div class="row align-items-center">
        <!-- Imagen del Gym -->
        <div class="col-lg-6 mb-4 mb-lg-0">
          <img src="../assets/images/gym-about.webp" alt="Victoria Gym" class="img-fluid rounded shadow-lg about-image parallax">
        </div>

        <!-- Texto -->
        <div class="col-lg-6">
          <h2 class="display-5 fw-bold mb-4 about-title fade-right">
            <i class="bi bi-activity"></i> 🏋️‍♂️ ¿Qué es Victoria Fitness Center?
          </h2>

          <p class="about-text fade-right delay-1">
            <i class="bi bi-check-circle-fill text-primary"></i>
            <strong>Victoria Gym</strong> es más que un centro de entrenamiento.
          </p>
          <p class="about-text fade-right delay-2">
            <i class="bi bi-lightning-fill text-primary"></i>
            Es un espacio diseñado para <strong>transformar tu energía en resultados</strong>.
          </p>
          <p class="about-text fade-right delay-3">
            <i class="bi bi-shield-fill-check text-primary"></i>
            Nuestro logo representa <strong>fuerza, determinación y orgullo</strong>: un atleta en posición de victoria sobre un escudo que simboliza protección, enfoque y constancia.
          </p>
          <p class="about-text fade-right delay-4">
            <i class="bi bi-stars text-primary"></i>
            Cada detalle, desde el diseño hasta el ambiente, está pensado para <strong>motivar tu mejor versión</strong>.
          </p>
          <p class="about-text fade-right delay-5">
            <i class="bi bi-people-fill text-primary"></i>
            Contamos con <strong>entrenadores expertos</strong>, rutinas personalizadas y un entorno que te impulsa a dar lo máximo.
          </p>
          <p class="about-text fade-right delay-6">
            <i class="bi bi-fire text-danger"></i>
            🔥 Aquí se entrena con propósito. Ya sea que busques <strong>ganar masa muscular</strong>, <strong>mejorar tu resistencia</strong> o simplemente <strong>sentirte más fuerte</strong>, en Victoria Gym te damos las herramientas, el acompañamiento y la motivación para lograrlo.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add("visible");
    });
  }, { threshold: 0.2 });

  document.querySelectorAll(".fade-right").forEach(el => observer.observe(el));
});
</script>

<style scoped>
/* Fondo blanco elegante */
#about-gym {
  background-color: #fff;
  color: #111;
  padding-top: 5rem;
  padding-bottom: 5rem;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
}

/* Título */
.about-title {
  color: #111;
  text-shadow: none;
}

/* Imagen con hover y parallax ligero */
.about-image {
  width: 100%;
  object-fit: cover;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  transition: transform 0.5s ease;
}
.about-image:hover { transform: scale(1.05); }

/* Animación fade-right */
.fade-right {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.fade-right.visible { opacity: 1; transform: translateX(0); }

/* Retrasos de animación */
.delay-1 { transition-delay: 0.2s; }
.delay-2 { transition-delay: 0.4s; }
.delay-3 { transition-delay: 0.6s; }
.delay-4 { transition-delay: 0.8s; }
.delay-5 { transition-delay: 1s; }
.delay-6 { transition-delay: 1.2s; }

/* Texto */
.about-text {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-weight: 600;
}
.about-text i {
  margin-right: 0.5rem;
}

/* Responsive */
@media (max-width: 992px) {
  .fade-right { transform: translateX(0); }
  .about-image { margin-bottom: 2rem; }
}
@media (max-width: 768px) {
  .about-title { font-size: 2rem; }
  .about-text { font-size: 1rem; }
}
</style>
